import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { serialization, unstack, stack, tensor, tidy, range, image } from '@tensorflow/tfjs-core';
import { getExactlyOneShape, getExactlyOneTensor } from '../../utils/types_utils';
import { Layer } from '../../engine/topology';
import * as K from '../../backend/tfjs_backend';
var resizeBilinear = image.resizeBilinear,
  cropAndResize = image.cropAndResize;
var CenterCrop = /*#__PURE__*/function (_Layer) {
  _inherits(CenterCrop, _Layer);
  function CenterCrop(args) {
    var _this;
    _classCallCheck(this, CenterCrop);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CenterCrop).call(this, args));
    _this.height = args.height;
    _this.width = args.width;
    return _this;
  }
  _createClass(CenterCrop, [{
    key: "centerCrop",
    value: function centerCrop(inputs, hBuffer, wBuffer, height, width, inputHeight, inputWidth, dtype) {
      return tidy(function () {
        var input;
        var isRank3 = false;
        var top = hBuffer / inputHeight;
        var left = wBuffer / inputWidth;
        var bottom = (height + hBuffer) / inputHeight;
        var right = (width + wBuffer) / inputWidth;
        var bound = [top, left, bottom, right];
        var boxesArr = [];
        if (inputs.rank === 3) {
          isRank3 = true;
          input = stack([inputs]);
        } else {
          input = inputs;
        }
        for (var i = 0; i < input.shape[0]; i++) {
          boxesArr.push(bound);
        }
        var boxes = tensor(boxesArr, [boxesArr.length, 4]);
        var boxInd = range(0, boxesArr.length, 1, 'int32');
        var cropSize = [height, width];
        var cropped = cropAndResize(input, boxes, boxInd, cropSize, 'nearest');
        if (isRank3) {
          return K.cast(getExactlyOneTensor(unstack(cropped)), dtype);
        }
        return K.cast(cropped, dtype);
      });
    }
  }, {
    key: "upsize",
    value: function upsize(inputs, height, width, dtype) {
      return tidy(function () {
        var outputs = resizeBilinear(inputs, [height, width]);
        return K.cast(outputs, dtype);
      });
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      var _this2 = this;
      return tidy(function () {
        var rankedInputs = getExactlyOneTensor(inputs);
        var dtype = rankedInputs.dtype;
        var inputShape = rankedInputs.shape;
        var inputHeight = inputShape[inputShape.length - 3];
        var inputWidth = inputShape[inputShape.length - 2];
        var hBuffer = 0;
        if (inputHeight !== _this2.height) {
          hBuffer = Math.floor((inputHeight - _this2.height) / 2);
        }
        var wBuffer = 0;
        if (inputWidth !== _this2.width) {
          wBuffer = Math.floor((inputWidth - _this2.width) / 2);
          if (wBuffer === 0) {
            wBuffer = 1;
          }
        }
        if (hBuffer >= 0 && wBuffer >= 0) {
          return _this2.centerCrop(rankedInputs, hBuffer, wBuffer, _this2.height, _this2.width, inputHeight, inputWidth, dtype);
        } else {
          return _this2.upsize(inputs, _this2.height, _this2.width, dtype);
        }
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'height': this.height,
        'width': this.width
      };
      var baseConfig = _get(_getPrototypeOf(CenterCrop.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      inputShape = getExactlyOneShape(inputShape);
      var hAxis = inputShape.length - 3;
      var wAxis = inputShape.length - 2;
      inputShape[hAxis] = this.height;
      inputShape[wAxis] = this.width;
      return inputShape;
    }
  }]);
  return CenterCrop;
}(Layer);
/** @nocollapse */
CenterCrop.className = 'CenterCrop';
export { CenterCrop };
serialization.registerClass(CenterCrop);